
        Component.define('page-news', (el, params) => {
            const $el = $(el);

$el.find('[name=year]').on('change', function(){
    let val = $(this).val();
    $('[data-component="filter-vehicle"]').find('[name=year]').val(val);

    let data = [];
    data.push({ name: 'year', value: $('[data-component="filter-vehicle"]').find('[name=year]').val() });
    data.push({ name: 'categoria', value: $('[name=categoria]').val() });
    data.push({ name: 'brand', value: $('[name=brand]:checked').val() });
    $('[name="product[]"]:checked').each(function(){ data.push({ name: 'product[]', value: $(this).val() });});
    data.push({ name: 'input', value: 'year' });
    data.push({ name: 'termo', value: $('[name=termo][type=hidden]').val() });

    console.log(data);

    $('[data-component="filter-vehicle"]').trigger('submit', [Object.assign(data)]);
});

$el.find('.btn-load-more').on('click', function(e){
    loading.show();
    e.preventDefault();
    let $this = $(this);
    let url = $this.attr('href');
    $.ajax({
        method: "get",
        url: url
    })
    .done(function( data ) {
        setTimeout(function(){
            loading.hide();
            $el.find('.wrap-boxes').append(data.html);
            window.SvgFix();
            $window.trigger('scroll');
            if(data.nextPageUrl){
                $this.attr('href', data.nextPageUrl);
            } else {
                $this.hide();
            }
        },1000);
    });
});

        });